import script from "./Freelance.vue?vue&type=script&setup=true&lang=js"
export * from "./Freelance.vue?vue&type=script&setup=true&lang=js"

import "./Freelance.vue?vue&type=style&index=0&id=784b6984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-784b6984"]])

export default __exports__